// extracted by mini-css-extract-plugin
module.exports = {"group":"CookieToast_group__23le9","pill":"CookieToast_pill__2LYaC","pillText":"CookieToast_pillText__1gxOK","pin":"CookieToast_pin__f9kTa"};